export const getCampaignById = async (id, server) => {
    try {
        if (!id) {
            return null;
        }
        
        const response = await server.getById(id);
        
        if (response && response.error === 'OK' && response.data) {
            return response.data;
        }
        
        console.error('Error fetching campaign:', response);
        return null;
    } catch (error) {
        console.error('Error in getCampaignById:', error);
        return null;
    }
};
